import * as R from 'ramda';

type ReorderItems = (startIndex: number, index: number, item: any) => Function;
/**
 * Returns a reorder function that should be called with the array whose items should be reordered.
 *
 * @param startIndex start index
 * @param index current index
 * @param item item to be reordered
 */
export const reorderItems: ReorderItems = (startIndex: number, index: number, item: any) => {
  const insertPosition = startIndex < index ? index - 1 : index;
  const removeOldItem = R.remove(startIndex, 1);
  const insertNewItem = R.insert(insertPosition, item);
  return R.compose(insertNewItem, removeOldItem);
};
